import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { AccessLevel } from '../lib/permissions';

export function RequireAuth({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="centered muted">Loading…</div>;
  // Carry the destination through sign-in (see lib/returnPath.ts) so a deep
  // link — e.g. "Open ticket" from Slack — survives having to log in first.
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  return <>{children}</>;
}

/**
 * Route-level permission check. Cosmetic only — wpcursor-admin-api and
 * wpcursor-backend both enforce the same rule server-side.
 */
export function RequireModule({
  module, level = 'read', children,
}: { module: string; level?: AccessLevel; children: ReactNode }) {
  const { can } = useAuth();
  if (!can(module, level)) {
    return (
      <div className="empty-state">
        <h2>No access</h2>
        <p>
          You need <strong>{level}</strong> access to <strong>{module}</strong>.
          Ask a superadmin if you think this is wrong.
        </p>
      </div>
    );
  }
  return <>{children}</>;
}
